import { render, staticRenderFns } from "./medicine.vue?vue&type=template&id=a53af0b6&scoped=true"
import script from "./medicine.vue?vue&type=script&lang=js"
export * from "./medicine.vue?vue&type=script&lang=js"
import style0 from "./medicine.vue?vue&type=style&index=0&id=a53af0b6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a53af0b6",
  null
  
)

export default component.exports